<template>
  <v-container grid-list-lg fluid>
    <v-card outlined>
      <v-toolbar dense flat color="grey lighten-3">
        <v-app-bar-nav-icon @click="$router.go(-1)">
          <v-icon>mdi-chevron-left</v-icon>
        </v-app-bar-nav-icon>

        <v-toolbar-title>Setting</v-toolbar-title>
        <v-spacer></v-spacer>
        <span v-if="Setting">Code:
          <span class="font-weight-medium">{{ Setting.code }}</span></span>
      </v-toolbar>

      <MesbaAccess />

      <v-card-title primary-title> Business Info </v-card-title>
      <div v-if="Setting">
        <v-card-text>
          <v-row>
            <v-col cols="6" sm="12" md="6">
              <v-text-field outlined dense :error-messages="nameErrors" :hide-details="nameErrors.length === 0"
                v-model="Setting.metadata.dbaName" label="DBA Name"></v-text-field>
            </v-col>
            <v-col cols="6" sm="12" md="6">
              <v-text-field outlined dense :error-messages="nameErrors" :hide-details="nameErrors.length === 0"
                v-model="Setting.name" label="Business Name"></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field outlined dense :error-messages="emailErrors" :hide-details="emailErrors.length === 0"
                v-model="Setting.email" label="Email Address"></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field outlined dense :error-messages="phoneNumberErrors"
                :hide-details="phoneNumberErrors.length === 0" v-model="Setting.phoneNumber"
                label="Phone Number"></v-text-field>
            </v-col>
            <v-col cols="12" sm="12">
              <v-text-field outlined hide-details dense v-model="Setting.website" label="Web Site"></v-text-field>
            </v-col>
            <v-card-title primary-title> Address </v-card-title>
            <v-col cols="12" sm="12">
              <v-text-field outlined hide-details dense v-model="Setting.address" label="Address"></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field outlined dense hide-details v-model="Setting.city" label="City"></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="3">
              <v-text-field outlined dense hide-details v-model="Setting.state" label="State"></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="3">
              <v-text-field outlined hide-details dense v-model="Setting.zip" label="Zip Code"></v-text-field>
            </v-col>
            <v-col cols="12" sm="12">
              <v-textarea auto-grow hide-details outlined dense v-model="Setting.policy" label="Policy"></v-textarea>
            </v-col>
            <v-col cols="12" sm="12">
              <v-textarea auto-grow hide-details outlined dense v-model="Setting.metadata.taxExam"
                label="Tax Exam Message"></v-textarea>
            </v-col>
            <v-col cols="12" sm="12">
              <v-textarea auto-grow hide-details outlined dense v-model="Setting.metadata.termsAndConditions"
                label="Terms & Conditions"></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-title primary-title>
          <v-row>
            <v-col cols="12"> Logo </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12">
              <v-btn icon color="red">
                <v-icon>delete</v-icon>
              </v-btn>
              <v-btn icon color="info" @click="pickFile">
                <v-icon>attach_file </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-layout align-center justify-center column fill-height>
            <v-layout class="ma-6" align-center justify-center column fill-height>
              <img height="120" v-if="imageUrl" :src="imageUrl" alt="Logo" />
              <img height="120" v-else src="../../assets/images/uploadphoto.png" alt="Logo" />
            </v-layout>
          </v-layout>

          <input type="file" ref="image" style="display: none" accept="image/*" @change="onFilePicked" />
        </v-card-text>
      </div>
      <v-card-title primary-title>Tuition billing defaults</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="6" sm="6">
            <v-select label="Monthly billing day" :items="list" outlined item-text="name" item-value="id" dense hide-details
              v-model="Setting.metadata.defaultDay">
            </v-select>
            <!-- <v-text-field outlined dense hide-details v-model="Setting.metadata.defaultDay"
              label="Select Default Date"></v-text-field> -->
          </v-col>
          <v-col cols="6" sm="6">
            <v-autocomplete v-model="Setting.metadata.defaultProduct" hide-no-data ref="productSearch" outlined
              prepend-inner-icon="search" dense :loading="loading" auto-select-first single-line hide-details clearable
              id="productSearch" :items="Products" item-text="name" return-object label="Select Fee Product">
              <template slot="item" slot-scope="{ item }">
                <span>{{ item.name }}</span>
                <v-spacer></v-spacer>
                <v-chip v-if="item.isFee" color="pink" label text-color="white">
                  <v-icon left>
                    mdi-label
                  </v-icon>
                  School Fee
                </v-chip>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field v-model="Setting.metadata.automaticCollectionStartDate" type="date" outlined dense hide-details label="Automatic collection start date" />
          </v-col>
          <v-col cols="12">
            <v-alert text dense type="info" class="mb-0">Normal schedule: invoices and email notices are created two days before the monthly billing day, and automatic collection begins on that day. If a current-month invoice is missing, the nightly catch-up run may create and collect it after the billing day.</v-alert>
          </v-col>
          <v-col cols="12">
            <v-alert text dense type="info" class="mb-0">Invoices dated before this date will never be charged automatically. They remain available for manual review and payment.</v-alert>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-title primary-title>Default payment categories</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="6" sm="6">
            <div>School Fee</div>
            <v-autocomplete v-model="Setting.DefaultSchoolFeeId" hide-no-data outlined
              prepend-inner-icon="search" dense :loading="loading" auto-select-first single-line hide-details clearable
               :items="MerchantAccount" item-text="name" item-value="id" label="Default tuition payment category">
              <template slot="item" slot-scope="{ item }">
                <span>{{ item.name }}</span>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="6" sm="6">
            <div>Donation</div>
            <v-autocomplete v-model="Setting.DefaultDonationId" hide-no-data outlined
              prepend-inner-icon="search" dense :loading="loading" auto-select-first single-line hide-details clearable
               :items="MerchantAccount" item-text="name" item-value="id" label="Default donation payment category">
              <template slot="item" slot-scope="{ item }">
                <span>{{ item.name }}</span>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-title class="term-completion-title">
        <div>
          <div>Report card deadlines</div>
          <small>Control when teachers can no longer change grades after a term ends.</small>
        </div>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model.number="termCompletion.termLockDelayDays"
              type="number"
              min="1"
              step="1"
              outlined
              dense
              suffix="days"
              label="Term lock delay"
              hint="A term completes this many days after its end date. Default: 10 days."
              persistent-hint
              :error-messages="termLockDelayErrors"
              @input="$v.termCompletion.termLockDelayDays.$touch()"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model.number="termCompletion.termUnlockDurationDays"
              type="number"
              min="1"
              step="1"
              outlined
              dense
              suffix="days"
              label="Temporary unlock duration"
              hint="A completed term stays reopened for this many days. Default: 2 days."
              persistent-hint
              :error-messages="termUnlockDurationErrors"
              @input="$v.termCompletion.termUnlockDurationDays.$touch()"
            />
          </v-col>
          <v-col cols="12" class="text-right pt-0">
            <v-btn color="primary" depressed :loading="termCompletionLoading" @click="saveTermCompletion">
              Save report card deadlines
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="pink" dark :loading="loading" @click="submit()">update</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
import RegisterStoreModule from "@/mixins/RegisterStoreModule";
import userStore from "./store.js";
import settingService from "./service";
import { mapGetters } from "vuex";

const { validationMixin } = require("vuelidate");
const { required, minLength, email } = require("vuelidate/lib/validators");
import productService from "@/modules/Product/service";
import donationCategoryService from "@/modules/DonationCategory/service.js";
import MesbaAccess from "./components/MesbaAccess.vue";

export default {
  name: "setting",
  components: {
    MesbaAccess,
  },
  data() {
    return {
      loading: true,
      imageName: "",
      imageUrl: "",
      imageFile: "",
      list: [
        { id: 1, name: '1' },
        { id: 2, name: '2' },
        { id: 3, name: '3' },
        { id: 4, name: '4' },
        { id: 5, name: '5' },
        { id: 6, name: '6' },
        { id: 7, name: '7' },
        { id: 8, name: '8' },
        { id: 9, name: '9' },
        { id: 10, name: '10' },
        { id: 11, name: '11' },
        { id: 12, name: '12' },
        { id: 13, name: '13' },
        { id: 14, name: '14' },
        { id: 15, name: '15' },
        { id: 16, name: '16' },
        { id: 17, name: '17' },
        { id: 18, name: '18' },
        { id: 19, name: '19' },
        { id: 20, name: '20' },
        { id: 21, name: '21' },
        { id: 22, name: '22' },
        { id: 23, name: '23' },
        { id: 24, name: '24' },
        { id: 25, name: '25' },
        { id: 26, name: '26' },
        { id: 27, name: '27' },
        { id: 28, name: '28' },
        { id: 29, name: '29' },
        { id: 30, name: '30' },
        { id: 31, name: '31' },
      ],
      Products: [],
      MerchantAccount: [],
      Setting: {
        metadata: {
          liveStripeId: null,
          termsAndConditions: null,
          defaultProduct: null
        },
      },
      metadata: {
        termsAndConditions: null,
        liveStripeId: null,
        dbaName: null,
      },
      termCompletionLoading: false,
      termCompletion: {
        termLockDelayDays: 10,
        termUnlockDurationDays: 2,
      },
    };
  },
  created() {
    this.registerStoreModule("setting", userStore);
    this.getSetting();
    this.getProduct();
    this.getMerchantAccount()
    this.getTermCompletion();
    document.title = "taleem - Setting";
  },
  // watch: {
  //   imageUrl(val) {
  //     this.Setting.image = val;
  //   },
  // },
  computed: {
    ...mapGetters("global", ["currentBusiness"]),
    emailErrors() {
      const errors = [];
      if (!this.$v.Setting.email.$dirty) return errors;
      if (!this.$v.Setting.email) errors.push("Email is not valid");
      if (!this.$v.Setting.email.required) errors.push("Email is required.");
      return errors;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.Setting.name.$dirty) return errors;
      if (!this.$v.Setting.name.minLength)
        errors.push("Field must be at least 5 characters long");
      if (!this.$v.Setting.name.required)
        errors.push("Business Name is required.");
      return errors;
    },
    phoneNumberErrors() {
      const errors = [];
      if (!this.$v.Setting.phoneNumber.$dirty) return errors;
      if (!this.$v.Setting.phoneNumber.required)
        errors.push("Phone Number is required.");
      return errors;
    },
    termLockDelayErrors() {
      if (!this.$v.termCompletion.termLockDelayDays.$dirty) return [];
      return this.$v.termCompletion.termLockDelayDays.positiveInteger ? [] : ["Enter a whole number of at least 1"];
    },
    termUnlockDurationErrors() {
      if (!this.$v.termCompletion.termUnlockDurationDays.$dirty) return [];
      return this.$v.termCompletion.termUnlockDurationDays.positiveInteger ? [] : ["Enter a whole number of at least 1"];
    },
  },
  mixins: [validationMixin, RegisterStoreModule],
  validations: {
    Setting: {
      name: {
        required,
        minLength: minLength(5),
      },
      email: {
        required,
        email,
      },
      phoneNumber: {
        required,
      },
    },
    termCompletion: {
      termLockDelayDays: { positiveInteger: value => Number.isInteger(Number(value)) && Number(value) >= 1 },
      termUnlockDurationDays: { positiveInteger: value => Number.isInteger(Number(value)) && Number(value) >= 1 },
    },
  },
  methods: {
    async getTermCompletion() {
      this.termCompletionLoading = true;
      try {
        const result = await settingService.getTermCompletion();
        this.termCompletion = { ...this.termCompletion, ...(result.data || {}) };
      } catch (error) {
        this.$swal.fire({ icon: "error", title: "Report card settings unavailable", text: (error.data && error.data.message) || "Please refresh and try again." });
      } finally {
        this.termCompletionLoading = false;
      }
    },
    async saveTermCompletion() {
      this.$v.termCompletion.$touch();
      if (this.$v.termCompletion.$invalid) return;
      this.termCompletionLoading = true;
      try {
        const result = await settingService.updateTermCompletion(this.termCompletion);
        this.termCompletion = { ...this.termCompletion, ...(result.data || {}) };
        this.$v.termCompletion.$reset();
        this.$swal.mixin({ toast: true, position: "top-end", showConfirmButton: false, timer: 3000 }).fire({ icon: "success", title: "Report card deadlines updated" });
      } catch (error) {
        this.$swal.fire({ icon: "error", title: "Could not save deadlines", text: (error.data && error.data.message) || "Please try again." });
      } finally {
        this.termCompletionLoading = false;
      }
    },
    getMerchantAccount() {
      this.loading = true;
      return donationCategoryService.getAll().then((result) => {
        this.MerchantAccount = result.data;
        console.log('MerchantAccount', this.MerchantAccount)
        this.loading = false;
      });
    },
    getProduct() {
      this.loading = true;
      return productService.getAll({ isFee: true }).then((result) => {
        this.Products = result.data;
        this.loading = false;
      });
    },
    pickFile() {
      this.$refs.image.click();
    },
    onFilePicked(e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.imageUrl = fr.result;
          this.Setting.image = this.imageUrl;
          this.imageFile = files[0]; // this is an image file that can be sent to server...
        });
      } else {
        this.imageName = "";
        this.imageFile = "";
        this.imageUrl = "";
      }
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        this.loading = true;
        console.log("setting", this.Setting);
        return settingService
          .update(this.Setting.id, this.Setting)
          .then((result) => {
            if (result.status) {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                })
                .fire({
                  icon: "success",
                  title: "Setting is updated!",
                });
              this.loading = false;
              this.$router.go(-1);
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: err.data.message,
              });
          });
      }
    },
    getSetting() {
      this.loading = true;
      return settingService.getById(this.currentBusiness.id).then((result) => {
        this.Setting = result.data;
        console.log('result, result', result)
        if (!this.Setting.metadata) {
          this.Setting.metadata = {
            liveStripeId: null,
          };
        }

        this.Setting.metadata = {
          ...this.metadata,
          ...this.Setting.metadata,
        }
        if (this.Setting.metadata.defaultDay && typeof this.Setting.metadata.defaultDay === "object") {
          this.Setting.metadata.defaultDay = Number(this.Setting.metadata.defaultDay.id);
        }
        if (!this.Setting.metadata.automaticCollectionStartDate) {
          this.Setting.metadata.automaticCollectionStartDate = "2026-08-01";
        }

        // console.log('l;aksdjfas;djklf', this.Setting)
        // console.log("got setting", result);
        if (this.Setting.imageUrl) this.imageUrl = this.Setting.imageUrl;
        this.loading = false;
      });
    },
  },
};
</script>
<style scoped>
.term-completion-title > div { display: flex; flex-direction: column; gap: 3px; }
.term-completion-title small { color: #718096; font-size: 12px; font-weight: 400; }
</style>
